import './App.css';
import NavbarN from './Component/NavbarN/NavbarN';
import Footer from './Component/Footer/Footer';
import Home from './Component/Home/Home';
import Page2 from './Component/Page2/Page2';
import Page3 from './Component/Page3/Page3';

function App() {
  return (
 <div className='main-div'>
 <NavbarN />
 {/* <Home/> */}
 <Page2 />
 <Page3 />
 <Footer />
 </div>
  );
}

export default App;
